import { HashLoader } from "react-spinners";
import { useTrips } from "../../context/TripsContext";
import { useCallback, useEffect, useState } from "react";
import { BookingResponseData } from "../../@types";
import { useNavigate } from "react-router-dom";

const NewFlight = () => {
  const { bookingURL, booking, setBooking, setBookingResponse,
    initializingNewFlight, isInitializeError, retryInitialization } = useTrips();
  const [isLoading, setIsLoading] = useState(true);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    setBooking(true);
  }, [setBooking]);

  const retry = () => {
    setIsLoading(true);
    setReloadKey((key) => key + 1);
    retryInitialization();
  };

  const navigate = useNavigate();

  const handleMessage = useCallback(
    (message: any) => {
      try {
        const isTripOrigin = message.origin.includes("trip") ||
          (process.env.NODE_ENV === "development" && message.origin.includes("localhost"));
        if (isTripOrigin) {
          const data = JSON.parse(message.data);
          
          // DEBUG: Capture widget payload for backend testing
          console.log("[DEBUG_WIDGET_PAYLOAD] Received payload from trips widget:", data);
          (window as any).lastWidgetPayload = data;
          localStorage.setItem("visaro_debug_widget_payload", JSON.stringify(data, null, 2));

          setBooking(false);
          setBookingResponse(data as BookingResponseData);
          navigate("/aviation/select-payment-method");
        }
      } catch (error) {
        // do nothing
      }
    },
    [setBooking, setBookingResponse, navigate]
  );

  useEffect(() => {
    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [handleMessage]);

  return (
    <div className="w-full">
      <div className="p-4 flex flex-wrap items-center justify-between gap-3 border-b border-gray-200">
        <button type="button" onClick={() => navigate('/aviation')} className="font-medium">Back to flights</button>
        <div className="flex flex-wrap items-center gap-3 text-sm">
          <span>Flight search blank or not responding?</span>
          <button type="button" disabled={initializingNewFlight} onClick={retry} className="font-medium underline disabled:opacity-50">Reload flight search</button>
          <a href="mailto:support@visaro.ng?subject=Local%20flight%20search%20issue" className="font-medium underline">Contact support</a>
        </div>
      </div>
      {isInitializeError ? (
        <div role="alert" className="p-8 text-center space-y-3">
          <h1 className="text-xl font-medium">Flight search could not load</h1>
          <p>Please reload flight search. If it remains unavailable, contact support.</p>
        </div>
      ) : (isLoading || !bookingURL || !booking || initializingNewFlight) && (
        <div role="status" className="p-8 flex justify-center"><HashLoader /><span className="sr-only">Loading flight search</span></div>
      )}
      {bookingURL && booking && !isInitializeError && !initializingNewFlight && (
        <iframe
          key={reloadKey}
          src={bookingURL}
          title="New Flight"
          style={{ width: "100%", height: "90vh", border: "none" }}
          onLoad={() => setIsLoading(false)}
        />
      )}
    </div>
  );
};

export default NewFlight;
